import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function MagicCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    const run = async () => {
      if (!token) {
        navigate("/onboarding", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/magic/verify", { token });
        setUser(res.data.user);
        const dest = res.data.user?.is_commercial ? "/pro" : "/app";
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true, state: { user: res.data.user } });
      } catch (e) {
        // The token may have been consumed by a duplicate load while the session
        // was still established. If we're actually logged in now, proceed.
        try {
          const me = await api.get("/auth/me");
          if (me?.data?.user_id) {
            setUser(me.data);
            const dest = me.data?.is_commercial ? "/pro" : "/app";
            window.history.replaceState(null, "", dest);
            navigate(dest, { replace: true });
            return;
          }
        } catch (_) {}
        setError(e?.response?.data?.detail || "Lien invalide ou expiré.");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090b] px-6">
      {error ? (
        <div data-testid="magic-callback-error" className="text-center max-w-sm">
          <p className="text-lg font-bold text-zinc-100">Connexion impossible</p>
          <p className="text-sm text-zinc-400 mt-2">{error}</p>
          <button
            data-testid="magic-callback-retry"
            onClick={() => navigate("/onboarding", { replace: true })}
            className="mt-5 rounded-full bg-pink-500 text-white font-bold py-3 px-6 hover:bg-pink-600"
          >
            Redemander un lien
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full border-2 border-pink-500 border-t-transparent animate-spin" />
          <p className="text-zinc-400 text-sm">Connexion en cours…</p>
        </div>
      )}
    </div>
  );
}
